import { useCallback, useState } from 'react';
import { useTheme } from 'next-themes';
import { CustomIcon } from '../CustomIcon';
import ThemeToggle from '../Helper/ThemeToggle';
import { SidebarTrigger } from '@/components/ui/sidebar';
import Logo from '@/assets/svg/logo.svg';
import Breadcrumb from '../Breadcrumb';
import { Button } from '@/components/ui/button';
import CashbackModal from '@/components/modals/cashback-modal';
import { useRootSelector } from '@/hooks/selector.hook';
import { checkActionPermission } from '@/utils/permission';

export const Header = () => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  const [isCashbackModalOpen, setIsCashbackModalOpen] = useState(false);
  const globalActions = useRootSelector((state) => state.permission.globalActions);

  const checkPermissions = useCallback(
    (actionIds: string | string[] | undefined) => {
      if (!actionIds) return true;
      const ids = Array.isArray(actionIds) ? actionIds : [actionIds];
      return ids.some((id) => checkActionPermission(globalActions, id));
    },
    [globalActions]
  );

  const handleOpenCashbackModal = () => {
    setIsCashbackModalOpen(true);
  };

  const handleCloseCashbackModal = () => {
    setIsCashbackModalOpen(false);
  };

  return (
    <>
      <header className="bg-transparent px-3 py-3 lg:px-[2rem] flex items-center justify-between">
        {/* Left side - 50% width on mobile */}
        <div className="flex items-center space-x-4 w-1/2 lg:w-auto">
          <SidebarTrigger className="[&>svg]:!h-[3rem] [&>svg]:!w-[3rem]" />
          <Breadcrumb />
        </div>

        {/* Mobile Logo - centered */}
        <div className="logo lg:hidden flex justify-center absolute left-1/2 transform -translate-x-1/2">
          <img className="w-[12rem]" src={Logo} alt="" />
        </div>

        {/* Right side - 50% width on mobile */}
        <div className="flex items-center gap-[0.8rem] md:gap-[1.2rem] lg:gap-[1.5rem] w-1/2 lg:w-auto justify-end">
          {checkPermissions("view_cashback") && <Button
            onClick={handleOpenCashbackModal}
            className="text-[#121212] fixed lg:static bottom-[8rem] z-[50] text-[1.6rem] p-[1.2rem] lg:h-[4.8rem] lg:w-auto w-[6rem] h-[6rem] rounded-[1.8rem] bg-[#57E8BA] font-medium"
          >
            <CustomIcon type="cashback-sidebar" className="w-[2.4rem] h-[2.4rem]" />
            <span className='hidden lg:block'>Cashback</span>
          </Button>}


          {/* Notifications */}
          <div className="dark:bg-[#353535] bg-[#F5F5F5] lg:p-[0.8rem] p-[0.4rem] rounded-[1rem] dark:shaddow-none shadow-[0px_1px_2.3px_0px_#0000002E]">
            {isDark ? (
              <CustomIcon type="bell" className="w-auto h-[1.5rem] lg:h-auto" />
            ) : (
              <CustomIcon type="bellLight" className="w-auto h-[1.5rem] lg:h-auto" />
            )}
          </div>
          {/* Theme Toggle */}
          <ThemeToggle />
        </div>
      </header>

      {/* Cashback Modal */}

      <CashbackModal
        open={isCashbackModalOpen}
        closeModal={handleCloseCashbackModal}
      />
    </>
  );
};

export default Header;
